import { getSkuPart } from '../getSkuPart';

/**
 * Method to generate a valid sku
 *
 * @param sku - sku as string or undefined
 * @param isPreselectDimension - a boolean that indicates if the sku is a preselected dimension
 * @returns - a sanitized sku (sku with 2 parts)
 */

export const getSanitizedSku = (sku: string, isPreselectDimension: boolean): string => {
  const parts = getSkuPart(sku, 'PartsAsObject');
  const isLegacySku = parts.masterStyleCommunicationKey !== null;

  if (!isLegacySku) return sku;

  return isPreselectDimension && isLegacySku
    ? `${parts.articleNumber}-${parts.size}`
    : parts.articleNumber || '';
};
